import {localFind} from "../utils/api";

export const GET_MANEUVER_TYPES = 'GET_MANEUVER_TYPES';
export const GET_MANEUVER_TYPES_SUCCEEDED = 'GET_MANEUVER_TYPES_SUCCEEDED';
export const GET_MANEUVER_TYPES_FAILED = 'GET_MANEUVER_TYPES_FAILED';
export const getManeuverTypes = localFind('v1/maneuverType/find', GET_MANEUVER_TYPES, GET_MANEUVER_TYPES_SUCCEEDED, GET_MANEUVER_TYPES_FAILED);
